/*
	File: init.js
	Author: D McCleod
	Created: 2/08/2017
	Modified:
	Description: initialize Slick carousel with config object on $dom ready
*/


// will be set by a var in the jsp
const slideShowWrapper = $('#slide-show-v2');
const slideContainer = $('.slide-container');
const startSlide =  1; // default, changed in init.slideshow.js dom ready to be what ever slide is loaded in hash
const wrapperClassNames = ['first-slide', 'last-slide'];

// will be set by test and target platform
const bSwipeAd = (typeof tt_slideshow != 'undefined' && tt_slideshow != null) ? tt_slideshow.swipe : true;

const configObj = {
    adaptiveHeight: true,
	arrows: true,
	slide: '.crs-slide',
	prevArrow: '.crs_nav_arrow--back',
	nextArrow: '.crs_nav_arrow--forward',
	appendArrows: '.crs-slide_arrows',
    lazyLoad: 'null',
	infinite: false,
    initialSlide: 1,
	slidesToShow: 1,
    slidesToScroll:1,
    useTransform: false,
	swipe: true,
	responsive: [{
		breakpoint: 300,
		settings: {
			touchThreshold: 4,
			edgeFriction: 3.5,
			speed: 2500
		}
	}]
};

const adConfig = {
    adaptiveHeight: false,
	arrows: false,
    slide: '.inter-slide',
    infinite: false,
    initialSlide: 1,
    slidesToShow: 1,
    slidesToScroll:1,
    swipe: bSwipeAd
};


export {
    slideContainer,
    configObj,
    startSlide,
    slideShowWrapper,
    wrapperClassNames,
	adConfig
};